<script lang="ts">
    import KpGenericPanel from '../panel/KpGenericPanel.svelte';

    export let additionalClasses = '';
</script>

<KpGenericPanel additionalClasses="vertical-buttons-panel {additionalClasses}">
    <slot name="heading" slot="heading"></slot>
    <slot></slot>
</KpGenericPanel>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    :global {
        .vertical-buttons-panel {
            .panel-body {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: @spacing-sm;

                // Bootstrap has default before and after elements on
                // panel-body class. We remove them, because they
                // collide with flex-gap - additional gaps were being added
                &::before,
                &::after {
                    display: none;
                }

                & > * {
                    margin: 0;
                }

                .kp-button,
                .kp-button-style-link {
                    white-space: normal; // to break/wrap long button labels
                }
            }
        }
    }
</style>